import { useQuery } from "@tanstack/react-query";
import { statisticsRepository } from "@/config/dataSource";
import { computeLeagueAnalytics } from "@/modules/leagues/utils/leagueAnalytics";

export function useLeagueAnalytics(leagueId: string | undefined) {  return useQuery({
    queryKey: ["league-analytics", leagueId ?? "unknown"],
    queryFn: async () => {
      const [participants, mostPredictedScore] = await Promise.all([
        statisticsRepository.getParticipants(leagueId as string),
        statisticsRepository.getMostPredictedScore(leagueId as string),
      ]);
      return { ...computeLeagueAnalytics(participants), mostPredictedScore };
    },
    enabled: Boolean(leagueId),
  });
}
